import React, { useState } from 'react';
import "./RJSCDetailReview.styles.scss"
import Modal from 'react-modal'
import {connect} from 'react-redux';
import {rjscDetailReviewSelect} from '../../redux/selector/rjscSearchSelector'
import {setCompanyRjscDetails} from '../../redux/slice/rjscDetailReviewSlice'
import {
    Header, 
    Paragraph,
    Button,
    SubHeader,
    LineSeperator
} from '../../components/RegularComponents'
import { push } from 'connected-react-router';
import TopNavigationBar from '../TopNavigationBar';
import {APPLICATION_MODE_NEW, APPLICATION_MODE_RENEW, APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE, APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE, APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE, RJSC_UPDATE_LINK, ROUTE_PATH} from '../../app/constants'
import { replaceUrlParams } from '../../app/utils';
import Navigation from '../Navigation';
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import { ERROR_STRING } from '../../app/errors';
import CompliaceOfficerConfirm from "../../components/RJSCReview/ComplianceOfficerConfirm";

const RJSCDetailReview = (props) => {
    const {rjscDetailReview} = props
    const{applicationType, applicationMode} = props.match.params

    const [showUpdateRjscDetailDialog, setShowUpdateRsjcDetailDialog] = useState(false)
    const [showCompanyNotActiveError,setShowCompanyNotActiveError] = useState(false)
    const [complaiceOfficerCheck, setComplaiceOfficerCheck] = useState(false);
    const [unmatchedComplianceOfficerError, setUnmatchedComplianceOfficerError] = useState(false);

    // console.log(rjscDetailReview)
    const onSaveNextClick = () => {
        const validation = (rjscDetailReview.companyRjscData.status === "ACTIVE"
            || !rjscDetailReview.companyRjscData.businessEntity)
        

        if(validation) {
            props.dispatch(setCompanyRjscDetails(rjscDetailReview.companyRjscData))

                if(applicationMode === APPLICATION_MODE_RENEW) {
                    if (
                    !complaiceOfficerCheck &&
                    (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE ||
                        applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE)
                ) {
                    setUnmatchedComplianceOfficerError(true);
                    return;
                }

                let nextUrl = ROUTE_PATH.APPLICATION_RENEWAL_REVIEW

                if(applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) {
                    nextUrl = `${ROUTE_PATH.ML_APP}${ROUTE_PATH.RENEWAL_COMPLIANCE_OFFICER}`;
                } else if(applicationType === APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) {
                    nextUrl = `${ROUTE_PATH.MA_APP}${ROUTE_PATH.RENEWAL_COMPLIANCE_OFFICER}`;
                } else if(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) {
                    nextUrl = `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.RENEWAL_COMPLIANCE_OFFICER}`;
                }
                
                props.dispatch(push(replaceUrlParams(nextUrl, applicationType, applicationMode)))
            } else {
                if(applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) { //3223520
                    props.dispatch(push(ROUTE_PATH.MRA_PRINCIPAL_BROKER))
                    return;
                }
    
                props.dispatch(push(replaceUrlParams(rjscDetailReview.navigation.next, applicationType, applicationMode)))
            }
        } else { 
            // show an error message explaining the problem
            setShowCompanyNotActiveError(true)
        }
    }

    // show RJSC search
    const handleNoClick = () => {
        const nextUrl = ROUTE_PATH.RJSC_SEARCH
        props.dispatch(push(replaceUrlParams(nextUrl, applicationType, applicationMode)))
    }

    const onUpdateInfoClick = () => {
        setShowUpdateRsjcDetailDialog(true)
    }

    return (
        <>
            <Navigation {...props} />
            <div className={"container"}>
            <TopNavigationBar {...props} />
            <div className="row">
                <div className="col-lg-8">
                    <Header 
                        id="rjsc-detail-review-header"
                        header={rjscDetailReview.header} />
                    <Paragraph 
                        id="rjsc-detail-review-text"
                        text={rjscDetailReview.text} />
                </div>
            </div>

            <div className="row bottomMarginNormal">
                <div className="col-lg-8">
                    <SubHeader subHeader={"Company information"}/>
                    <ReviewForm data={rjscDetailReview.companyReview} fullSize={true} />
                    
                    <LineSeperator style={{borderColor: "#777", borderWidth: "2px"}}/>

                    <SubHeader subHeader={"Officials listed under RJSC"}/>
                    <div className="companyPeopleReviewForm">
                    {
                        rjscDetailReview.peopleReview ? rjscDetailReview.peopleReview.map((people) => 
                        {
                            return (
                                <div className="companyPeopeReviewFormItem">
                                    <ReviewForm data={people} />
                                </div>
                            )
                        }) : null
                    }
                    </div>
                    <div className="row">
                        <div className="col-lg-8">
                            
                        </div>
                    </div>

                    {
                        applicationMode === APPLICATION_MODE_RENEW && (
                            <>
                            {(applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE || APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE) ? null : (
                                <div className="topMarginMedium">
                                    <Paragraph 
                                        id="rjsc-detail-review-accuracy-text"
                                        text={[`Is this business information accurate?`]} />
                                </div>
                            )}
                            <CompliaceOfficerConfirm
                                applicationMode={applicationMode}
                                applicationType={applicationType}
                                complaiceOfficerCheck={complaiceOfficerCheck}
                                setComplaiceOfficerCheck={setComplaiceOfficerCheck}
                                unmatchedComplianceOfficerError={unmatchedComplianceOfficerError}
                                setUnmatchedComplianceOfficerError={setUnmatchedComplianceOfficerError}
                            />
                            <div className="row topMarginMedium">
                                <div className="col-lg-3 col-ls-2">
                                    <Button 
                                        className="ns-btn-yes-no btn-default"
                                        id={"rjsc-detail-yes-button"}
                                        text={"Yes"}
                                        buttonType={"regular_primary"}
                                        onClick={onSaveNextClick}
                                    />
                                </div>
                                <div className="col-lg-3 col-ls-2">
                                    <Button
                                        className="ns-btn-yes-no btn-default" 
                                        id={"rjsc-detail-no-button"}
                                        text={"No"}
                                        buttonType={"regular_primary"}
                                        onClick={handleNoClick}
                                    />
                                </div>
                                <div className="col-lg-5 col-ls-2" style={{
                                                display: "flex", 
                                                flexDirection: "column", 
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}>
                                    <Button 
                                        id={"rjsc-detail-update-info"}
                                        text={"Update outdated information in RJSC"}
                                        buttonType={"regular_primary"}
                                        onClick={onUpdateInfoClick}
                                        className="btn ns-btn-2nd"
                                    />
                                </div>
                            </div>
                            </>
                        )
                    }
                    {
                        applicationMode === APPLICATION_MODE_NEW && (
                            <>
                            <div className="row topMarginNormal">
                                <div className="col-auto">
                                    <div className="has-error">
                                        <div className="help-block">
                                            <Button 
                                                id={"rjsc-detail-save-next"}
                                                text={"Save and next"}
                                                buttonType={"regular_primary"}
                                                onClick={onSaveNextClick}
                                            />
                                            {showCompanyNotActiveError && <span style={{marginLeft : "5px"}}>
                                                <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                            </span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <Button 
                                        id={"rjsc-detail-update-info"}
                                        text={"Update outdated information in RJSC"}
                                        buttonType={"regular_primary"}
                                        onClick={onUpdateInfoClick}
                                        className="btn ns-btn-2nd"
                                    />
                                </div>
                            </div>
                            </>
                        )
                    }
                    {showCompanyNotActiveError && <div className="row">
                        <div className="col-lg-12 topMarginNormal">
                            <div className="has-error">
                                {ERROR_STRING.RJSC_STATUS_NOT_ACTIVE}
                            </div>
                        </div>
                    </div>}
                </div>
            </div>

            <Modal 
                appElement={document.getElementById('root')}
                isOpen={showUpdateRjscDetailDialog}
                contentLabel="rjscDetailUpdateDialog"
                onRequestClose={() => {  }}
                shouldCloseOnEsc={false}
                shouldCloseOnOverlayClick={false}
                className="modalDialogContent updateRjscDetailDialog"
                closeTimeoutMS={150}>
                    <div className="row pull-right">
                        <div className="col-lg-1 closeButton" onClick={() => {
                            setShowUpdateRsjcDetailDialog(false)
                        }}>
                            <i className="fa fa-2x fa-times"></i>
                        </div>
                    </div>
                    <Header header={rjscDetailReview.updateRjscDetailDialog.header}/>
                    <p dangerouslySetInnerHTML={{__html: (applicationMode === APPLICATION_MODE_RENEW ? rjscDetailReview.updateRjscDetailDialog.htmlTextRenewal : rjscDetailReview.updateRjscDetailDialog.htmlText)}}>
                    </p>
                    <a 
                        className={"btn btn-primary"}  
                        href={RJSC_UPDATE_LINK}
                        target={"_blank"}
                        rel={"noreferrer"}
                        id={"update-rjsc-anchor"}
                        style={{marginTop: "20px"}}>
                            {"Continue to RJSC"}
                    </a>
            </Modal>
            
        </div>
        </>
    )
}

export default connect(rjscDetailReviewSelect)(RJSCDetailReview)
